<template>
    <div class="mx-auto header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('hec.saving.confirmTitle') }}</h3>
        </div>

        <form @submit.prevent="handleOnSubmit">
            <!-- Forthing送金設定 -->
            <div class="setting-box">
                <label class="setting-title">{{ $t('hec.saving.forthingSettingTitle') }}</label>
                :
                <span v-if="this.forthing_setting === 0">
                    <!-- OFF -->
                    <label class="label-value" for="forthing_off">{{ $t('hec.saving.offLabel') }}</label>
                </span>
                <span v-else>
                    <!-- 2年 -->
                    <label  class="label-value" for="forthing_two">{{ $t('hec.saving.twoYearsLabel') }}</label>
                </span>
            </div>

            <!-- EX BONUS送金設定 -->
            <div class="setting-box">
                <label class="setting-title">{{ $t('hec.saving.exBonusSettingTitle') }}</label>
                :
                <span v-if="this.ex_bonus_setting === 0">
                    <!-- OFF -->
                    <label class="label-value" for="exbonus_off">{{ $t('hec.saving.offLabel') }}</label>
                </span>
                <span v-else>
                    <!-- 2年 -->
                    <label class="label-value" for="exbonus_two">{{ $t('hec.saving.twoYearsLabel') }}</label>
                </span>
            </div>
            
            <div class="setting-box">
                <label class="confirm-msg">{{ $t('hec.saving.ConfirmMessageText') }}</label>
            </div>

            <div class="text-center">
                <div class="pb-4 ">
                    <button type="button" class="btn btn-primary" @click="back">{{ $t('hec.saving.btnBackText') }}</button>
                    <button type="submit" class="btn btn-primary">{{ $t('hec.saving.btnUpdateText') }}</button>
                </div>
            </div>
        
        </form>
    </div>
</template>

<script>
    import HecSavingService from '../../services/HecSavingService';

    export default {
        name: 'automatic-remittance-confirm',

        data() {
            return {
                forthing_setting: '',
                ex_bonus_setting: '',
            }
        },

        async mounted() {
        },

        created() {
            this.getConfirmData();
        },

        methods: {
            async getConfirmData() {
                if(sessionStorage.formData){
                    this.formData = JSON.parse(sessionStorage.formData);
                    this.forthing_setting = Number(this.formData.forthing_setting);
                    this.ex_bonus_setting = Number(this.formData.ex_bonus_setting);
                } else {
                    // セッションストレージが存在しない場合ログイン後トップ画面に遷移
                    this.$router.push('/');
                }

            },
            back: function(event){
                this.$router.push('/hec-saving/automatic-remittance');
            },
            async handleOnSubmit() {
                try {
                        this.forthing_setting_data = String(this.forthing_setting);
                        this.ex_bonus_setting_data = String(this.ex_bonus_setting);

                        var data =
                        { 
                            "forting" : {"plan" : this.forthing_setting_data},
                            "exbonus" : {"plan" : this.ex_bonus_setting_data}
                        };
                        // 自動送付設定登録処理
                        const result_data = (await HecSavingService.setReserveHecSavingSettingHistory(data)).data;
                        
                        if(result_data.result === true) {
                            // sessionStorageの削除処理
                            sessionStorage.removeItem('formData')
                            // 完了画面へ遷移
                            this.$router.push('/hec-saving/automatic-remittance-complete');
                        }
                } catch (err) {
                }
            },
        }
    }
</script>

<style scoped>
    .form-group {
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .setting-box{
        text-align:center;
        margin-top: 20px;
        margin-bottom: 20px; 
    }
    .label-value {
        width: 60px;
        text-align: left; 
    }
    .setting-title{
        width: 220px;
        text-align: center; 
    }
    .confirm-msg{
        text-align: center;
        margin-top: 10px; 
    }
    .btn-primary {
        width: 115px;
        margin-top: 10px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    @media (min-width: 992px){
        .col-lg-4 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    @media (min-width: 768px){
        .col-md-6 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    @media (min-width: 576px){
        .col-sm-12 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
</style>
